import { languages as allLanguages } from 'lifesum-web/src/js/locale/constants'
import { getLocation } from 'lifesum-web/src/js/locale/utils'

export function getLanguage() {
  // Languages may be appended both in CMS and by the client, always use the last one
  const languages = new URLSearchParams(getLocation().search).getAll('language')
  let paramLanguage = languages[languages.length - 1]

  if (!paramLanguage) return null
  let language = paramLanguage.substr(0, 2)

  if (language.startsWith('nb')) language = 'no'
  if (language.startsWith('nn')) language = 'no'

  return allLanguages.includes(language) ? language : 'en'
}

export function getCountry() {
  if (new URLSearchParams(getLocation().search).get('country'))
    return new URLSearchParams(getLocation().search)
      .get('country')
      .toUpperCase()
}
